module.exports = __webpack_public_path__ + "static/О некоторых вопросах развития ГГС РС(Я).doc";